import React from 'react';
import { Notification } from 'services';
import { fluid } from 'components/UserDashboardV2/utils/responsive';
import ArrowSquareLeft from '../dashboardV3/arrow-square-left.svg';
import ArrowSquareRight from '../dashboardV3/arrow-square-right.svg';
import DiscountIcon from '../dashboardV3/discount-badge.svg';
import { formatFeeDate, getResourceTypeBadge } from './feeUtils';

const FeeOneTimePlan = ({
    currentFee,
    courseName,
    batchInfo,
    activeFeeIndex,
    feeListLength,
    resourceType,
    totalFee,
    discountsList,
    onPrevFee,
    onNextFee,
    onDownloadInvoice,
}) => {
    const badgeInfo = getResourceTypeBadge(resourceType);
    const purchasedOnText = formatFeeDate(currentFee.purchasedOn || currentFee.createdAt);

    return (
        <div style={{ display: "flex", gap: fluid(24), alignItems: "flex-start", flex: 1, minHeight: 0 }}>
            {/* Left Card */}
            <div style={{ flex: `1 1 ${fluid(882)}`, backgroundColor: "#FFFFFF", borderRadius: fluid(24), padding: fluid(24), boxSizing: "border-box", display: "flex", flexDirection: "column", gap: fluid(20) }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: fluid(16) }}>
                        <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(20), fontWeight: 500, color: "#191919" }}>
                            {courseName}
                        </span>
                        <div style={{ display: "flex", gap: fluid(6) }}>
                            <img
                                src={ArrowSquareLeft}
                                alt="Prev"
                                onClick={onPrevFee}
                                style={{ width: fluid(32), height: fluid(32), cursor: activeFeeIndex > 0 ? "pointer" : "default", opacity: activeFeeIndex > 0 ? 1 : 0.4 }}
                            />
                            <img
                                src={ArrowSquareRight}
                                alt="Next"
                                onClick={onNextFee}
                                style={{ width: fluid(32), height: fluid(32), cursor: activeFeeIndex < feeListLength - 1 ? "pointer" : "default", opacity: activeFeeIndex < feeListLength - 1 ? 1 : 0.4 }}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: fluid(16) }}>
                        {batchInfo && (
                            <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#666666", fontWeight: 400 }}>
                                {batchInfo}
                            </span>
                        )}
                        {purchasedOnText && (
                            <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#666666", fontWeight: 400 }}>
                                Purchased on {purchasedOnText}
                            </span>
                        )}
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#666666" }}>Course fee</span>
                    <span style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: fluid(22),
                        padding: `0 ${fluid(10)}`,
                        borderRadius: fluid(4),
                        backgroundColor: badgeInfo.bg,
                        border: `1px solid ${badgeInfo.border}`,
                        color: badgeInfo.color,
                        fontFamily: "Roboto, sans-serif",
                        fontSize: fluid(12),
                        fontWeight: 600,
                        lineHeight: fluid(18),
                        boxSizing: "border-box",
                        whiteSpace: "nowrap"
                    }}>
                        {badgeInfo.text}
                    </span>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: `calc(${fluid(8)} * -1)` }}>
                    <div style={{ display: "flex", alignItems: "center", gap: fluid(12) }}>
                        <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(24), fontWeight: 600, color: "#191919" }}>
                            ₹{totalFee.toLocaleString()}
                        </span>
                        <span style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: fluid(22),
                            padding: `0 ${fluid(10)}`,
                            borderRadius: fluid(4),
                            backgroundColor: "#ECFDF5",
                            border: "1px solid #34D399",
                            color: "#059669",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: fluid(12),
                            fontWeight: 600,
                            lineHeight: fluid(18),
                            boxSizing: "border-box",
                            whiteSpace: "nowrap"
                        }}>
                            {currentFee.status || "Paid"}
                        </span>
                        <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#666666" }}>
                            via {currentFee.paymentMethod || "UPI"}
                        </span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: fluid(24) }}>
                        <span
                            onClick={() => Notification.info("Initiate Refund", "Refund action will be available soon.")}
                            style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), fontWeight: 700, color: "#594099", cursor: "pointer", letterSpacing: "0.5px" }}
                        >
                            INITIATE REFUND
                        </span>
                        <span
                            onClick={() => onDownloadInvoice(currentFee)}
                            style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), fontWeight: 700, color: "#594099", cursor: "pointer", letterSpacing: "0.5px" }}
                        >
                            VIEW INVOICE
                        </span>
                    </div>
                </div>
            </div>

            {/* Right Card (Discounts) */}
            <div style={{ flex: `0 0 ${fluid(598)}`, width: fluid(598), backgroundColor: "#FFFFFF", borderRadius: fluid(24), padding: fluid(24), boxSizing: "border-box", display: "flex", flexDirection: "column", gap: fluid(16) }}>
                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(20), fontWeight: 500, color: "#191919" }}>
                    Discounts
                </span>
                {discountsList.length > 0 ? (
                    discountsList.map((d, dIdx) => (
                        <div key={dIdx} style={{ width: "100%", backgroundColor: "#F8F8F8", borderRadius: fluid(16), padding: fluid(16), boxSizing: "border-box", display: "flex", gap: fluid(16), alignItems: "center" }}>
                            <div style={{ width: fluid(45), height: fluid(45), borderRadius: fluid(12), backgroundColor: "#DCF2B7", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <img src={DiscountIcon} alt="" style={{ width: fluid(24), height: fluid(24) }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", minWidth: 0, flex: 1 }}>
                                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(16), color: "#1A1A1A", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {d.name || "Early bird — 10%"}
                                </span>
                                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#666666", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    &minus;₹{Number(d.amount || 0).toLocaleString()} applied
                                </span>
                            </div>
                        </div>
                    ))
                ) : (
                    <div style={{ padding: fluid(16), backgroundColor: "#F8F8F8", borderRadius: fluid(16), color: "#888888", fontSize: fluid(15), fontFamily: "Roboto, sans-serif" }}>
                        No discounts applied.
                    </div>
                )}
            </div>
        </div>
    );
};

export default FeeOneTimePlan;
